import { ReportRunStatus } from '../data-view';
import { ReportRunFormField } from './parameters.types';

export enum dbtStateStatus {
  ok = 'ok',
  info = 'info',
  error = 'error',
}

export enum ReportRunBannerTypes {
  LastSuccessfulRunWithNewerFailure = 'LastSuccessfulRunWithNewerFailure',
  SuccessfulRunWithNewerSuccess = 'SuccessfulRunWithNewerSuccess',
  FailedRunWithNewerSuccess = 'FailedRunWithNewerSuccess',
  FailedRunWithoutNewerSuccess = 'FailedRunWithoutNewerSuccess',
  NoBanner = 'NoBanner',
}

export type ReportRunBannerType = keyof typeof ReportRunBannerTypes;

export interface DbtDetailTable {
  name: string;
  sourceDataLastLoadedAt: string;
  details: string;
  oldestSource: string;
}

export interface ReportDbtMetaData {
  message: string;
  sourceDataLastLoadedAt: string | null;
  state: dbtStateStatus;
  tables: Array<DbtDetailTable>;
  views: number;
  lastEdit: string;
  lastSuccessfulRun?: string;
}

export interface ReportFeatureState {}

export interface ReportThemeResource {
  css_href: string;
  css_source: string;
  name: string;
  token: string;
}

export interface ReportTheme {
  name: string;
  token: string;
  href: string;
  customSource: string | undefined;
}

// @TODO (@anthonysimone) [GF] - This should just be an updated version of `ReportRunResource`, however, migrating that over
// will likely be a larger PR because of dependencies. Come back to this after p->r work is finished.
export interface ReportRunMetadata {
  completed_at: string;
  has_more_recent_successful_run_available: boolean;
  is_latest_report_run: boolean;
  is_latest_successful_report_run: boolean;
  purge_completed_at?: string;
  purge_started_at?: string;
  report_has_failures_since_last_success: boolean;
  form_fields: ReportRunFormField[];
  state: ReportRunStatus;
  token: string;

  _links: {
    latest_successful_report_run_api_url: { href: string };
  };
}
